var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWithNameHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Artwork",
    viewBox: "0 0 180 90",
    width: 180,
    height: 90,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.348602,
    y: 33.500538,
    width: 5.6129427,
    height: 21.273083,
    id: "rect6",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.62130058
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 100.11454,24.140767 a 3.2150389,3.2150389 0 1 0 3.29448,3.213417 3.177749,3.177749 0 0 0 -3.29448,-3.213417 z",
    id: "path8",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.62130058
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.835,41.073 109.146,41.073 113.837,54.194 117.852,54.194 122.543,41.073 118.856,41.073 115.845,50.507 ",
    id: "polygon10",
    transform: "matrix(1.6213006,0,0,1.6213006,-70.413849,-33.091142)",
    style: {
      fill: "#fc686e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 139.90288,32.97199 c -6.0588,0 -10.41199,4.79905 -10.41199,11.225885 a 10.611411,10.611411 0 0 0 11.18696,11.104287 10.103944,10.103944 0 0 0 8.94958,-4.677452 l -3.70466,-2.812957 a 6.2047169,6.2047169 0 0 1 -5.16547,2.60381 5.1670847,5.1670847 0 0 1 -5.53188,-4.880116 h 14.96947 c 0.0405,-0.406945 0.0405,-0.81065 0.0405,-1.220839 0,-6.950515 -3.74195,-11.342618 -10.33254,-11.342618 z m -4.5137,8.909046 a 4.5088366,4.5088366 0 0 1 4.59476,-4.312659 4.3467067,4.3467067 0 0 1 4.55747,4.312659 z",
    id: "path12",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.62130058
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 93.024587,44.110324 a 11.2194,11.2194 0 1 0 -5.43946,9.604585 5.8674864,5.8674864 0 0 1 -10.282288,2.689737 l -4.101891,3.404731 a 11.20805,11.20805 0 0 0 19.823639,-7.167769 h -3.957591 a 11.186973,11.186973 0 0 0 3.957591,-8.531284 z m -11.208049,5.870729 a 5.8707291,5.8707291 0 1 1 5.870731,-5.870729 5.875593,5.875593 0 0 1 -5.870731,5.870729 z",
    id: "path14",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.62130058
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 163.64196,32.912003 a 11.20805,11.20805 0 0 0 0,22.414479 11.214535,11.214535 0 0 0 0,-22.414479 z m 0,17.078779 a 5.8707291,5.8707291 0 1 1 5.87072,-5.87073 5.8788356,5.8788356 0 0 1 -5.87072,5.87073 z",
    id: "path16",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.62130058
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 47.999454,36.683147 a 21.154729,21.154729 0 1 0 -10.257968,18.111548 11.063754,11.063754 0 0 1 -19.390754,5.0617 l -7.735225,6.438184 A 21.135273,21.135273 0 0 0 47.999454,52.777797 h -7.457982 a 21.086634,21.086634 0 0 0 7.457982,-16.09465 z M 26.86418,47.753387 a 11.071861,11.071861 0 1 1 11.07024,-11.07024 11.08321,11.08321 0 0 1 -11.07024,11.07024 z",
    id: "path18",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.62130058
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithNameHorizontal);
export default __webpack_public_path__ + "static/media/logo-with-name-horizontal.57bc84d8b9e640de0cb1b35330191f69.svg";
export { ForwardRef as ReactComponent };